import {
  ArrowLongRightIcon,
  Button,
  Input,
  KeyIcon,
  Link,
  PhoneIcon,
  routeToUrl,
  success,
  useCustomForm,
} from "@";
import { forgotPassword } from "./utils/api";
import { forgotPasswordSchema } from "./utils/validation";

const ForgotPassword = () => {
  const { errors, register, handleSubmit, isSubmitting } = useCustomForm(
    {},
    forgotPasswordSchema,
  );

  const submit = async (data) => {
    try {
      await forgotPassword(data);
      localStorage.setItem("phoneNumber", data.phoneNumber);
      success("تم ارسال رمز التحقق");
      routeToUrl("/check-otp");
    } catch (error) {}
  };

  return (
    <div className="relative p-6 md:p-8">
      {/* Step indicator */}
      <div className="mb-5 flex items-center gap-2">
        <span className="inline-flex h-7 items-center gap-1.5 rounded-full bg-purple-50 px-2.5 text-[11px] font-bold uppercase tracking-[0.14em] text-purple-700 ring-1 ring-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:ring-purple-800/40">
          <KeyIcon className="h-3 w-3" />
          استعادة الحساب
        </span>
        <div className="flex items-center gap-1">
          <span className="h-1.5 w-6 rounded-full bg-purple-700 dark:bg-purple-400" />
          <span className="h-1.5 w-2 rounded-full bg-gray-200 dark:bg-gray-700" />
          <span className="h-1.5 w-2 rounded-full bg-gray-200 dark:bg-gray-700" />
        </div>
      </div>

      <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 md:text-3xl">
        نسيت كلمة المرور؟
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        لا تقلق! اكتب رقم هاتفك وسنرسل لك رمزاً عبر رسالة نصية لإنشاء كلمة مرور
        جديدة.
      </p>

      <form className="mt-7 space-y-5" onSubmit={handleSubmit(submit)}>
        <div className="relative *:mb-12 *:h-14 *:rounded-full">
          <Input
            star
            type="tel"
            label="رقم الهاتف"
            error={errors.phoneNumber}
            input={register("phoneNumber")}
            styles="input ps-10 h-14 rounded-full  dark:bg-transparent dark:border-gray-500"
          />
          <span
            aria-hidden
            className="pointer-events-none absolute start-3 top-[42px] text-gray-400 dark:text-gray-400"
          >
            <PhoneIcon className="h-6 w-6" />
          </span>
        </div>

        <Button
          type="submit"
          title="ارسال الرمز"
          isLoading={isSubmitting}
          className="!w-full rounded-full !py-3"
        />

        <div className="flex items-center justify-center gap-1 border-t border-gray-100 pt-5 dark:border-gray-700/60">
          <span className="text-xs text-gray-500 dark:text-gray-400">
            تذكرت كلمة المرور؟
          </span>
          <Link
            to="/login"
            className="group/link inline-flex items-center gap-1 text-xs font-semibold tracking-tight text-purple-700 hover:text-purple-900 dark:text-purple-400 dark:hover:text-purple-300"
          >
            تسجيل الدخول
            <ArrowLongRightIcon className="h-3.5 w-3.5 transition-transform group-hover/link:-translate-x-0.5 rtl:rotate-180" />
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
